<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-25 09:56:23
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveCanaelReason\LeaveCanaelReason.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-28 14:25:44
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_leaveCancelReason_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-leave-cancellation-reason')"
    @new="toNew"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :height="$vuetify.breakpoint.height - 275"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.reason="{ item }">
          <div
            class="text--primary table-title"
            :title="$getCommonLangValue(item.leave_reason_name)"
          >
            {{ $getCommonLangValue(item.leave_reason_name) }}
          </div>
        </template>
        <template v-slot:item.leave_reason_code="{ item }">
          <div
            class="text--primary table-title"
            :title="$getCommonLangValue(item.leave_reason_code)"
          >
            {{ $getCommonLangValue(item.leave_reason_code) }}
          </div>
        </template>

        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-leave-cancellation-reason')"
            :editBtn="hasBtn('edit-admin-leave-cancellation-reason')"
            :viewBtn="hasBtn('view-admin-leave-cancellation-reason')"
            :key="`tools-${item.uuid}`"
            :title="$t('label_essweb_leaveCancelReason_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "LeaveCanaelReason",
  computed: {},
  data() {
    return {
      showSelect: false,
      search: "",
      totalCount: 0,
      selected: [],
      headers: [
        {
          text: "label_essweb_leaveCancelReason_list_leaveCancelReasonNameLabel",
          value: "reason",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveCancelReason_from_codeLabel",
          value: "leave_reason_code",
          align: "start",
          sortable: false,
        },

        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_cancel_reason",
        url: "/leave-cancellation-reason/get-list/",
        data: { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
    toNew: function () {
      this.$toPage("/admin/leave-cancellation-reason/add", {});
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/leave-cancellation-reason/edit/"
          : "/admin/leave-cancellation-reason/detail/") + uuid
      );
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_cancel_reason",
        url: "/leave-cancellation-reason/delete/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_leaveCancelReason_list_deleteLeaveCancelReasonSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
  },
};
</script>
